<template>
    <form @submit="submitForm" novalidate>
        <div class="c-promo c-promo--events c-promo--shadow c-promo--row" aria-live="polite">
            
            <slot :formData="formData" :response="response" :validation="validation" :loading="loading" :isComplete="isComplete" :checkInput="checkInput" :validEmail="validEmail"></slot>

        </div>
    </form> 
</template>

<script>
    import axios from 'axios';
    import inputEventBus from '@/mixins/input-eventbus';

    export default {
        inject: ['EventBus'],
        props: {
            errorStepKey: {
                type: Number,
                default: 4
            }
        },
        data() {
            return {
                formData: {
                    commitment: [],
                    firstName: '',
                    lastName: '',
                    email: '',
                    zipCode: '',
                    newsletters: false,
                    URLReferral: ''
                },
                validation: {
                    commitment: false,
                    firstName: true,
                    lastName: true,
                    email: true,
                    zipCode: true
                },
                loading: false,
                response: false,
            }
        },
        methods: {
            submitForm(evt) {
                evt.preventDefault();
                const url = '/aha-service/grfw/MakeACommitment';
                this.loading = true;
                axios({
                    method: 'POST',
                    url: url,
                    responseType: 'json',
                    data: this.formData
                }).then(response => {
                    if(response.data === null) {
                        this.EventBus.$emit('stepTrigger', this.errorStepKey);
                        this.loading = false;
                    }
                    else {
                        if(response.data.AlreadyRegistered) {
                            this.response=true;
                        }
                        this.EventBus.$emit('stepTrigger');
                        this.loading = false;
                    }
                   
                }).catch(error => {
                    console.log(error)
                    this.EventBus.$emit('stepTrigger', this.errorStepKey);
                    this.loading = false;
                })
            },
            checkInput(value, evt) {
                if(evt.target.hasAttribute('validation-prop')) {
                    const validationProp = evt.target.getAttribute('validation-prop');
                    this.validation[validationProp] = value !== '' ? true : false;
                }
                return value;
            }
        },
        watch: {
            formData: {
                handler: function(value) {
                    for(let property in value) {
                        if(property === 'commitment') {
                            if(value[property].length > 0 ) {
                                this.validation[property] = true;
                            } else {
                                this.validation[property] = false;
                            }
                        }
                    }
                },
                deep: true
            }
        },
        computed: {
            isComplete() {

                return this.validEmail;
                
                
            },
            validEmail() {
                if(this.formData.firstName === '' || this.formData.lastName === '' || this.formData.email === '' || this.formData.zipCode === ''|| this.formData.newsletters === false){
                    console.log('Enter information in all fields');
                } else {
                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(this.formData.email);
                }
            }
        },
        created() {
            inputEventBus.$on('hiddenInputInit', (value, id) => {
                this.formData[id] = value;
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/app/components/aha-make-commitment-form.vue